module.exports = __webpack_public_path__ + "static/media/ridelightpro-4.9447c195.jpg";